'use strict';

import controller from './c-select-dpa.controller';
import template from './c-select-dpa.html';

const CSelectDPAComponent = {
  bindings: {
          ngModel: '=',
          ngRequired: '<?',
          ngDisabled: '<?',
          departamentos: '=?',
          provincias: '=?',
          municipios: '=?',
          selectMunicipio: '&?',
          horizontal: '=?'
  },
  require: {
    form: '^form',
  },
  template,
  controller
};

export default CSelectDPAComponent;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components/c-select-dpa/c-select-dpa.component.js